module.exports = __webpack_public_path__ + "img/banner_ongoing_CN.051fc74b.png";